export const fontStack = {
  default: {
    name: 'Brewed-Regular',
    weight: 400,
  },
  bold: {
    name: 'Brewed-Bold',
    weight: 700,
  },
  black: {
    name: 'Brewed-Black',
    weight: 900,
  },
  light: {
    name: 'Brewed-Light',
    weight: 500,
  },
  condensedLight: {
    name: 'Brewed-Light-Condensed',
    weight: 300,
  },
  designer: {
    name: 'grease_pencil',
    weight: 500,
  },
};
